/* eslint-disable */
import DispositionPivot from "./dispositionPivot.vue";

export default {
  name: "subjectDispositionReport",
  components: {
    DispositionPivot,
  },
  methods: {
    onclosed() {
      this.$router.push("./reportdashboard")
    }
  }
};